export default `return length(sin(p)+cos(p*.5))-.4;
  }`